'use client'

import { cn } from '@/lib/utils'
import { Input as InputShadCn } from '@/ui/Shadcn/input'
import { Label } from '@/ui/Shadcn/label'
import { useState } from 'react'

interface InputProps extends React.ComponentProps<typeof InputShadCn> {
  label?: string
  className?: string
  id?: string
  placeholder?: string
  [key: string]: any
}

const InputNumber = ({ label, className, id, ...props }: InputProps) => {
  const [value, setValue] = useState<number | null>(
    Number(props?.value) || null
  )
  const min = 0
  const max = 10

  const handleIncrement = () => {
    if (value && value < max && typeof value === 'number') {
      setValue(value + 1)
    }
  }

  const handleDecrement = () => {
    if (value && value > min) {
      setValue(value - 1)
    }
  }

  return (
    <div className={cn(`relative flex flex-col`, className)}>
      {label && (
        <Label
          htmlFor={id}
          className="top-md left-md absolute text-neutral-600"
        >
          {label}
        </Label>
      )}
      <InputShadCn
        id={id}
        type="number"
        value={value != null ? value : ''}
        min={min}
        max={max}
        step={1}
        onChange={(e) => setValue(Number(e.target.value))}
        className="px-md pb-xs pt-lg basic-input input-focus textstyle-md-regular h-auto"
        {...props}
      />

      {/* <div className="gap-xs p-xs absolute top-0 right-0 flex h-full items-center">
        <ButtonIcon
          onClick={() => handleIncrement()}
          type="button"
          icon="material-symbols:add"
          size="s"
        />
        <ButtonIcon
          onClick={() => handleDecrement()}
          type="button"
          icon="material-symbols:remove"
          size="s"
        />
      </div> */}
    </div>
  )
}

InputNumber.displayName = 'InputNumber'

export default InputNumber
